<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Material Requisition Form
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-row>
            <b-col lg="6" xl="5">
              <b-input-group>
                <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                <b-form-input v-model="model.requestno" readonly></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6" xl="5">
              <b-input-group>
                <b-input-group-append><span class="input-group-text">Request Date</span></b-input-group-append>
                <b-form-input v-model="model.requestdate" type="date" :max="maxDateRequest" @change="tanggalBerubah" :state="!$v.model.requestdate.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" xl="5">
              <b-input-group>
                <b-input-group-prepend><label>Request Type</label></b-input-group-prepend>
                <b-form-select v-model="model.jasa" :plain="true" :options="jasaMaterial" :state="!$v.model.jasa.$error"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Internal Budget No.</label></b-input-group-prepend>
                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuBudgetShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row align-h="between">
            <b-col lg="6" xl="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label>{{ labelExpected }}</label></b-input-group-prepend
                >
                <b-form-input v-model="model.expectreceipt" type="date" :state="!$v.model.expectreceipt.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6" xl="5">
              <b-input-group v-show="model.jasa">
                <b-input-group-prepend><label>Expect.Service Finish</label></b-input-group-prepend>
                <b-form-input v-model="model.jasafinish" type="date" :min="minServiceFinish" :state="!$v.model.jasafinish.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend
              ><label>{{ labelLocation }}</label></b-input-group-prepend
            >
            <b-form-input v-model="model.locationdeliv" placeholder="Delivery Location" :state="!$v.model.requestdate.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
            <b-form-input v-model="model.remark" :state="!$v.model.remark.$error" placeholder="Note/Remark"></b-form-input>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.barter" class="mt-1">BARTER</b-form-checkbox>
          </b-input-group>
        </b-col>
        <b-col md="4">
          <v-dim :model="model" :key="updateDimHdr"></v-dim>
        </b-col>
      </b-row>
      <b-card no-body class="mb-1">
        <b-table
          class="mb-0"
          ref="tblReqLines"
          outlined
          striped
          hover
          small
          style="font-size: smaller"
          :items="reqLines.items"
          :fields="reqLines.fields"
          :current-page="reqLines.page"
          :per-page="reqLines.limit"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(partnumber)="data"> {{ data.item.partnumber }} | {{ data.item.itemname }} </template>
          <template v-slot:cell(quantity)="data"> {{ data.item.quantity }} {{ data.item.invunitom }} </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click="editReqLines(data.item, data.toggleDetails)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click="delReqLines(data.index)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:row-details="row">
            <b-card class="row-details-form">
              <b-row align-h="center">
                <b-col lg="6" xl="6">
                  <b-input-group v-if="model.ibudghdkey">
                    <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                    <b-form-input v-model="reqLinesObj.budgetline" :state="!$v.reqLinesObj.ibudgdtkey.$error" readonly></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" @click="lkuBudgetInternShow = true">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                    <b-form-checkbox v-model="reqLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO" class="ml-2 pt-2">NOT RELATED</b-form-checkbox>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Master Item</label></b-input-group-prepend>
                    <b-form-input readonly v-model="reqLinesObj.iteminfo" @keyup.13.native="lkuItemShow = true" :state="!$v.reqLinesObj.itemno.$error"></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow = true">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend><label>Specs/Descript.</label></b-input-group-prepend>
                    <b-form-textarea :rows="3" :max-rows="10" v-model="reqLinesObj.description" :state="!$v.reqLinesObj.description.$error"></b-form-textarea>
                  </b-input-group>
                  <b-form-row>
                    <b-col md="6">
                      <b-input-group>
                        <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                        <b-form-input v-model="reqLinesObj.quantity" type="number"></b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col md="6">
                      <b-input-group>
                        <b-input-group-prepend><label style="width: 70px; text-align: right">Unit Size</label></b-input-group-prepend>
                        <b-form-input v-model="reqLinesObj.invunitom"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                </b-col>
                <b-col lg="6" xl="5">
                  <v-dim :model="reqLinesObj" :key="updateDimDtl"></v-dim>
                </b-col>
              </b-row>
              <b-row class="justify-content-center mt-1">
                <div style="width: 400px">
                  <b-input-group>
                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0" class="pt-2"></b-form-checkbox>
                    <b-input-group-append>
                      <b-button class="btn btn-success mr-1" @click="saveReqLines()">Update</b-button>
                    </b-input-group-append>
                    <b-input-group-append>
                      <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-row class="mt-1">
          <b-col cols="6">
            <b-row>
              <b-button size="sm" class="ml-3" @click.stop="addReqLines">Add Request item</b-button>
              <div class="ml-2">
                Showing {{ (reqLines.page - 1) * reqLines.limit + 1 }} to <span v-if="reqLines.page * reqLines.limit > reqLines.total">{{ reqLines.total }}</span>
                <span v-else>{{ reqLines.page * reqLines.limit }}</span>
                <strong> of {{ reqLines.total }} entries </strong>
              </div>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width: 80px !important"></b-form-input>
              <b-pagination :total-rows="reqLines.total" :per-page="reqLines.limit" v-model="reqLines.page"></b-pagination>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
        <button class="btn btn-danger mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
      </b-row>
    </b-card>
    <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
      <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
    </b-modal>
    <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
      <lku-item @click="onSelectLkuItem" isactive="1" :compcode="model.compcode" :formdata="itemList"></lku-item>
    </b-modal>
    <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
      <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
    </b-modal>
    <b-modal v-model="lkuBudgetInternShow" size="lg" :hide-footer="true" title="Internal Budget Items" :centered="true">
      <lku-budgetinternalline @click="onSelectLkuBudgetIntern" :ibudghdkey="model.ibudghdkey" :formdata="lkuBudgetInternData" :key="model.ibudghdkey"></lku-budgetinternalline>
    </b-modal>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../components/my-number";
import vDim from "./lookup/dim";
import lkuBudgetinternal from "./lookup/lkuBudgetinternal";
import lkuBudgetinternalline from "./lookup/lkuBudgetinternallineLazzy";
import lkuItem from "./lookup/lkuItemSaldoLazzy";
import lkuCoa from "./lookup/lkuCoa";
import mr from "../apis/logistic_mr";
import dimension from "../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, decimal, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, vDim, lkuBudgetinternal, lkuBudgetinternalline, lkuItem, lkuCoa },
  mixins: [validationMixin],
  validations: {
    model: {
      jasa: { required },
      requestdate: { required },
      expectreceipt: { required },
      jasafinish: { required: requiredIf("jasa") },
      remark: { required },
      locationdeliv: { required },
    },
    reqLinesObj: {
      ibudgdtkey: {
        required: function () {
          if (this.model.ibudghdkey) {
            if (this.reqLinesObj.ibudgdtkey) {
              if (this.reqLinesObj.ibudghdkey == "N/A") return true;
              else {
                if (this.model.ibudghdkey == this.reqLinesObj.ibudghdkey) {
                  return true;
                } else {
                  toastr.error(`Budget Line not from Internal Budget`, "Line/Detail Expenses", 10000);
                  return false;
                }
              }
            } else return false;
          } else return true;
        },
      },
      itemno: { required },
      description: { required },
      quantity: { decimal, required, minValue: minValue(0.01) },
    },
  },
  data() {
    return {
      saveEnabled: true,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lkuBudgetShow: false,
      lkuBudgetInternShow: false,
      lkuBudgetInternData: {},
      lkuCoaShow: false,
      lkuItemShow: false,
      updateDimHdr: false,
      updateDimDtl: true,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      maxDateRequest: moment(new Date()).format("YYYY-MM-DD"),
      uanguser: this.$store.state.user.matauang,
      dimension: this.$store.state.dimension,
      linetypes: [
        { value: 1, text: "Master Item " },
        { value: 3, text: "GL Account" },
      ],
      jasaMaterial: [
        { value: 1, text: "Service Request" },
        { value: 0, text: "Material Request" },
      ],
      itemList: {},
      labelLocation: "Delivery Location",
      labelExpected: "Expected Delivery",
      limit: 20,
      reqLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "partnumber",
            label: "Master Item",
            thStyle: "width:240px",
          },
          {
            key: "description",
            label: "Description",
            thStyle: "width:240px",
          },
          {
            key: "quantity",
            label: "Quantity",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 20,
        total: 0,
      },
      model: {
        ibudghdkey: "",
        jasa: 0,
        requestdate: "",
        expectreceipt: "",
        jasafinish: "",
        remark: "",
        matauang: this.$store.state.user.matauang,
        requestno: "",
        locationdeliv: this.$store.state.user.compaddr,
        compcode: this.$store.state.user.compcode,
      },
      reqLinesObj: {
        linetype: 1,
        iteminfo: "",
        itemno: "",
        invunitom: "",
        description: "",
        quantity: 1,
        ibudghdkey: "",
        ibudgdtkey: "",
        ibudgdtkeyflag: "YES",
      },
    };
  },
  computed: {
    invalidReqLines() {
      this.$v.reqLinesObj.$touch();
      return this.$v.reqLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    minServiceFinish() {
      return moment(this.model.expectreceipt).format("YYYY-MM-DD");
    },
  },
  watch: {
    jasa: function (newval) {
      if (newval) {
        this.labelLocation = "Service Location";
        this.labelExpected = "Expected Start";
      } else {
        this.labelLocation = "Delivery Location";
        this.labelExpected = "Expected Delivery";
      }
    },
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.reqLines.limit = newVal;
        }
      }, 500);
    },
  },
  created: async function () {
    if (this.$route.params.requestkey) {
      toastr.info("Loading Request Detail, please wait");
      try {
        const data = await mr.detail(this.$route.params);
        const row = data[0][0];
        if (row.isreject == 1) row.send2wf = 0;
        if (row.send2wf == 1) {
          if (row.isreviewed == 1) {
            this.saveEnabled = true;
          } else {
            this.saveEnabled = false;
          }
        }
        row.requestdate = row.requestdate ? moment(row.requestdate).format("YYYY-MM-DD") : "";
        row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format("YYYY-MM-DD") : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.reqLines.items = data[1];
        this.tanggalBerubah();
        this.updateDimHdr = !this.updateDimHdr;
        this.inputBerlanjut = 0;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.model.requestdate = moment().format("YYYY-MM-DD");
      const { cart } = this.$store.state;
      if (cart.items.length > 0) {
        cart.items.forEach((item) => {
          const ada = this.reqLines.items.find((i) => i.partnumber === item.code);
          if (ada) {
            ada.quantity += 1;
          } else {
            this.reqLines.items.push({
              linetype: 1,
              itemno: item.itemno,
              partnumber: item.partnumber,
              itemname: item.itemname,
              iteminfo: item.partnumber + "|" + item.itemname,
              description: "-",
              quantity: 1,
              invunitom: item.invunitom || "PCS",
            });
          }
        });
        this.reqLines.total = this.reqLines.items.length;
        this.$store.state.carts.items = [];
        localStorage.removeItem("cart");
      }
      this.model.requestdate = moment().format("YYYY-MM-DD");

      const dim = this.dimension.find((d) => d.RelatedObj == "department");
      if (dim) {
        this.model[`${dim.value}`] = this.$store.state.user.departkd;
        this.model[`${dim.value}Txt`] = this.$store.state.user.departemen;
        this.model[`${dim.value}Info`] = this.$store.state.user.departkd + " | " + this.$store.state.user.departemen;
      }
    }
    this.reqLines.total = this.reqLines.items.length;
  },
  methods: {
    // onSelectLkuBudget: async function (_selected) {
    //     try {
    //         this.model.remark = _selected.uraian;
    //         this.model.budgetname = _selected.uraian;
    //         this.model.budgetnumber = _selected.nomorintern;
    //         this.model.jccostname = _selected.jccostname;
    //         this.model.budgetinfo = _selected.nomorintern+' | '+_selected.jccostname;
    //         this.model.nomorproduksi = _selected.noprodintern;
    //         this.model.ibudgdtkey = _selected.ibudgdtkey;
    //         this.model.ibudghdkey = _selected.ibudghdkey;
    //         this.model.pjxbudgkey = _selected.pjxbudgkey;
    //         this.model.pjxkey = _selected.pjxhdrkey;
    //         this.model.DimTableKey = _selected.pjxhdrkey;
    //         this.budgetbalance = _selected.ibbudgetamt -_selected.requestamt;

    //         this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format('YYYY-MM-DD') : '';
    //         this.dimension.forEach((dim) => {
    //             if (_selected[dim.value]) {
    //                 this.model[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
    //             }
    //             if (dim.RelatedObj=='internalbudget') {
    //                 this.model[`${dim.value}`] = _selected.nomorintern;
    //                 this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
    //                 this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
    //             }
    //         });
    //         this.updateDimHdr=!this.updateDimHdr;

    //         this.lkuBudgetShow=false;
    //       } catch (error) {
    //             console.log('error : ', error);
    //             toastr.error(JSON.stringify(error), "ERROR MESSAGE");
    //       }
    // },
    onSelectLkuBudget: async function (_selected) {
      try {
        this.model.remark = _selected.uraian;
        this.model.budgetname = _selected.uraian;
        this.model.budgetnumber = _selected.nomorintern;
        this.model.budgetinfo = _selected.nomorintern + " | " + _selected.uraian;
        this.model.nomorproduksi = _selected.noprodintern;
        this.model.ibudghdkey = _selected.ibudghdkey;
        this.model.pjxbudgkey = _selected.pjxbudgkey;
        this.model.pjxkey = _selected.pjxhdrkey;
        this.model.DimTableKey = _selected.DimTableKey;

        this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format("YYYY-MM-DD") : "";
        this.dimension.forEach((dim) => {
          if (_selected[dim.value]) {
            this.model[dim.value] = _selected[dim.value];
            this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
            this.model[`${dim.value}Info`] = _selected[dim.value] + " | " + _selected[`${dim.value}Txt`];
          }
          if (dim.RelatedObj == "internalbudget") {
            this.model[`${dim.value}`] = _selected.nomorintern;
            this.model[`${dim.value}Txt`] = _selected.uraian + " # " + _selected.noprodintern;
            this.model[`${dim.value}Info`] = _selected.nomorintern + " | " + _selected.uraian + " # " + _selected.noprodintern;
          }
        });
        this.updateDimHdr = !this.updateDimHdr;

        this.lkuBudgetShow = false;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    onSelectLkuBudgetIntern: async function (ibLineObj) {
      try {
        this.reqLinesObj.jccostname = ibLineObj.selected.jccostname;
        this.reqLinesObj.budgetline = `${ibLineObj.selected.jccostname} ${ibLineObj.selected.jccostnote}`;
        this.reqLinesObj.ibudgdtkey = ibLineObj.selected.ibudgdtkey;
        this.reqLinesObj.ibudghdkey = ibLineObj.selected.ibudghdkey;
        this.reqLinesObj.ibudgdtkeyflag = "NO";
        if (!this.reqLinesObj.uraian) this.reqLinesObj.uraian = this.reqLinesObj.budgetline;
        if (ibLineObj.selected.itemname) {
          this.reqLinesObj.itemno = ibLineObj.selected.itemno;
          this.reqLinesObj.itemname = ibLineObj.selected.itemname;
          this.reqLinesObj.iteminfo = ibLineObj.selected.partnumber.trim() + " | " + ibLineObj.selected.itemname.trim();
          this.reqLinesObj.partnumber = ibLineObj.selected.partnumber;
          this.reqLinesObj.invunitom = ibLineObj.selected.invunitom || ibLineObj.selected.unitsize;
        }
        this.lkuBudgetInternShow = false;
        this.lkuBudgetInternData = ibLineObj;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    closeReqLines: function () {
      const opened = this.reqLines.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addReqLines: function () {
      this.closeReqLines();
      const obj = { _showDetails: true };
      this.reqLines.selected = obj;
      for (var key in this.reqLinesObj) {
        this.reqLinesObj[key] = "";
      }
      this.reqLinesObj.linetype = 1;
      this.reqLinesObj.invunitom = "EACH";
      this.reqLinesObj.quantity = 1;
      this.updateDimHdr2Dtl(this.reqLinesObj);
      this.reqLines.items.push(obj);
      this.reqLines.total = this.reqLines.items.length;
      setTimeout(() => {
        const bfore = this.reqLines.page;
        const after = Math.ceil(this.reqLines.total / this.reqLines.limit);
        if (bfore != after) {
          this.reqLines.page = after;
          toastr.info(`Move to page ${after} of total  ${reqLines.total} items`, "Line/Detail PR", 10000);
        }
      }, 100);
    },
    editReqLines: function (obj, callback) {
      this.closeReqLines();
      this.reqLines.selected = obj;
      for (var key in this.reqLinesObj) {
        this.reqLinesObj[key] = "";
      }
      for (var key in obj) {
        this.reqLinesObj[key] = obj[key];
      }
      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.reqLinesObj[dim.value] = obj[dim.value];
          this.reqLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.reqLinesObj[`${dim.value}Info`] = obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      callback();
    },
    delReqLines: function (index) {
      if (index > -1) {
        // this.reqLines.items.splice(index, 1);
        const posisi = (this.reqLines.page - 1) * this.reqLines.limit;
        this.reqLines.items.splice(posisi + index, 1);
      }
      this.reqLines.total = this.reqLines.items.length;
    },
    saveReqLines: async function (callback) {
      if (this.invalidReqLines) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        let datadim = this.reqLinesObj;
        datadim.TableName = "mr_sr_line";
        try {
          // const dimValResult = await dimension.validate(datadim);
          // if (dimValResult.success) {
          for (var key in this.reqLinesObj) {
            this.reqLines.selected[key] = this.reqLinesObj[key];
          }
          this.reqLines.selected.linetype = 1;
          this.dimension.forEach((dim) => {
            if (datadim[dim.value]) {
              this.reqLines.selected[dim.value] = datadim[dim.value];
              this.reqLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
            }
          });
          this.reqLines.total = this.reqLines.items.length;
          this.updateDimDtl2Hdr(datadim);
          this.reqLines.selected._showDetails = false;
          if (callback) callback();
          if (this.inputLineBerlanjut == 1) {
            this.addReqLines();
            this.$v.reqLinesObj.$reset();
          }

          // } else {
          //     var msg = dimValResult.message;
          //     if (callback) callback(new Error(msg));
          //     else {
          //         toastr.error(msg, "ERROR MESSAGE",10000);
          //     }
          // }
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.model.TableName = "mr_sr_header";
          const dimValResult = await dimension.validate(this.model);
          if (dimValResult.success) {
            // this.model.DimTableKey = diisi dari PR/SR;
            this.model.requestkey = this.model.requestkey || "";
            this.model.requestno = this.model.requestno || "";
            const row = {};
            for (var key in this.model) {
              row[key] = this.model[key];
            }
            row.terms = this.model.terms;
            row.requestdate = moment(row.requestdate).format("YYYY-MM-DD");
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format("YYYY-MM-DD") : undefined;
            if (this.model.jasa) {
              row.jasastart = row.expectreceipt;
              row.jasafinish = row.jasafinish ? moment(row.jasafinish).format("YYYY-MM-DD") : undefined;
            } else {
              row.jasastart = undefined;
              row.jasafinish = undefined;
            }
            let lineno = 1;
            row.lines = this.reqLines.items.reduce((newArr, item) => {
              if ((item.itemno || "") != "") {
                item.lineno = lineno;
                newArr.push(item);
                lineno += 1;
              }
              return newArr;
            }, []);
            if (row.lines.length > 0) {
              // await mr.save(row);
              // toastr.success("Complete successfully", "Save Request");
              const hasil = await mr.save(row);
              toastr.success(`Success, Trx.Number ${hasil.requestno}`, "Save Request", 10000);
              this.close();
            } else {
              toastr.error("Please fill at least 1(one) Request Detail", "ERROR MESSAGE");
              this.saveEnabled = true;
            }
          } else {
            this.saveEnabled = true;
            console.log("dimValResult : ", dimValResult);
            var msg = dimValResult.message || "Dimension validation error";
            toastr.error(msg, "ERROR MESSAGE");
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    showLkuCoa() {
      if (this.reqLinesObj.linetype == 3) this.lkuCoaShow = true;
      else this.lkuItemShow = true;
    },
    onSelectLkuCoa(_selected) {
      this.reqLinesObj.iteminfo = _selected.kodeacc.trim() + " | " + _selected.namaacc.trim();
      this.reqLinesObj.partnumber = _selected.namaacc;
      this.reqLinesObj.itemno = _selected.kodeacc;
      this.reqLinesObj.itemname = _selected.namaacc;
      this.lkuCoaShow = false;
    },

    onSelectLkuItem(lkuData) {
      this.itemList = lkuData;
      this.lkuItemShow = false;

      this.reqLinesObj.iteminfo = lkuData.selected.partnumber.trim() + " | " + lkuData.selected.itemname.trim();
      // this.reqLinesObj.description =  lkuData.selected.itemname.trim() + ' | ' + lkuData.selected.partnumber.trim();
      this.reqLinesObj.partnumber = lkuData.selected.partnumber;
      this.reqLinesObj.itemno = lkuData.selected.itemno || lkuData.selected.partnumber;
      this.reqLinesObj.itemname = lkuData.selected.itemname;
      this.reqLinesObj.invunitom = lkuData.selected.invunitom || lkuData.selected.unitsize;
    },
    updateDimDtl2Hdr: function (dimDtl) {
      var dimHdr = this.model;
      this.dimension.forEach((dim) => {
        if (dimDtl[dim.value] && !dimHdr[dim.value]) {
          dimHdr[dim.value] = dimDtl[dim.value];
          dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
          dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
        }
      });
      this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
      var dimHdr = this.model;
      dimDtl = dimDtl || this.reqLinesObj;
      this.dimension.forEach((dim) => {
        if (dimHdr[dim.value] && !dimDtl[dim.value]) {
          dimDtl[dim.value] = dimHdr[dim.value];
          dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
          dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
        }
      });
      this.updateDimDtl = !this.updateDimDtl;
    },
    tanggalBerubah: function () {
      this.tahun = moment(this.model.tanggal).format("YYYY");
    },
    close() {
      //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'logistic.mrform')) {
      //     router.push({name:this.$store.state.prevRoute.name});
      //   } else {
      router.push({ name: "app.requisition" });
      //   router.push("home");
      //   }
    },
  },
};
</script>
